<template>
    <Row type="none" class="bg-white rounded shadow">

        <Modal
            :text="modalText"
            id="modal_show"
            :on-ok-pressed="continuePay"
            :is-ok-only="false"
            :cancel-text="this.$t('no')"
            :ok-text="this.$t('yes')"
        />

        <div class="grid grid-cols-1 py-4 text-gray-500 font-bold">
            <div class="flex justify-center items-center">
                {{ $t('plan.mainTitle') }}
            </div>
            <div class="flex justify-center items-center">
                {{ $t('plan.subTitle') }}
            </div>
        </div>


        <Row type="none">

            <!--  mobile version  -->

            <RowColumn class="mt-3 d-block d-md-none">
                <div class="col table-sub-header-mobile">
                    {{ $t('plan.conditions') }}
                </div>

                <div class="col mt-3 p-0">
                    <div class="col text-center my-auto p-2 plan-lite table-border">Lite</div>
                </div>
                <div class="col table-body p-0">
                    <div class="d-flex">
                        <div class="col text-justify table-cell" style="overflow: auto">
                            <div class="text-center my-2 cell-title">{{ $t('plan.statistics') }}</div>
                            <p style="font-size: 15px">{{ $t('plan.statisticsTitle') }}</p>
                        </div>
                        <div class="col d-flex align-items-center justify-content-center table-cell">
                            <span class="checkmark-n">&#10005;</span>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="col text-center fixed-height py-5 table-sub-cell my-auto">
                            {{ $t('plan.employeesCount') }}
                        </div>
                        <div class="col text-center fixed-height my-auto table-sub-cell py-5">1</div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="col text-center fixed-height py-5 table-sub-cell my-auto">
                            {{ $t('plan.warehousesCount') }}
                        </div>
                        <div class="col text-center fixed-height my-auto table-sub-cell py-5">1</div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="col text-center fixed-height py-5 table-sub-cell my-auto">
                            {{ $t('plan.suppliersCount') }}
                        </div>
                        <div class="col text-center fixed-height my-auto table-sub-cell py-5">50</div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="col text-center fixed-height py-5 table-sub-cell my-auto">
                            {{ $t('plan.customersCount') }}
                        </div>
                        <div class="col text-center fixed-height my-auto table-sub-cell py-5">50</div>
                    </div>
                    <div class="d-flex">
                        <div
                            class="col d-flex align-items-center justify-content-center fixed-height table-sub-cell cell-title-price cell-fixed-height">
                            {{ $t('plan.priceForMonth') }}
                        </div>
                        <div class="col table-sub-cell fixed-height d-flex align-items-center">
                            <b-button
                                variant="primary"
                                @click="checkPreviousPlan('liteM')"
                                class="w-100"
                                style="background-color: red; border: none"
                            >
                                249 000 {{ $t('currencyRate.sum') }}
                            </b-button>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div
                            style="overflow: hidden"
                            class="col d-flex align-items-center text-center fixed-height table-sub-cell cell-title-price">
                            {{ $t('plan.priceForYear') }}
                        </div>
                        <div class="col table-sub-cell fixed-height d-flex align-items-center">
                            <b-button
                                variant="primary"
                                @click="checkPreviousPlan('liteA')"
                                class="w-100"
                                style="background-color: red; border: none"
                            >
                                2 490 000 {{ $t('currencyRate.sum') }}
                            </b-button>
                        </div>
                    </div>
                </div>

                <div class="col mt-4 p-0">
                    <div class="col text-center my-auto p-2 plan-standart table-border">Standart</div>
                </div>
                <div class="col table-body p-0">
                    <div class="d-flex justify-content-center">
                        <div class="col text-justify table-cell" style="overflow: auto">
                            <div class="text-center my-2 cell-title">{{ $t('plan.statistics') }}</div>
                            <p style="font-size: 15px">{{ $t('plan.statisticsTitle') }}</p>
                        </div>
                        <div class="col d-flex justify-content-center align-items-center table-cell">
                            <span class="checkmark">&#10003;</span>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="col text-center fixed-height py-5 table-sub-cell my-auto">
                            {{ $t('plan.employeesCount') }}
                        </div>
                        <div class="col text-center fixed-height my-auto table-sub-cell py-5">10</div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="col text-center fixed-height py-5 table-sub-cell my-auto">
                            {{ $t('plan.warehousesCount') }}
                        </div>
                        <div class="col text-center fixed-height my-auto table-sub-cell py-5">5</div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="col text-center fixed-height py-5 table-sub-cell my-auto">
                            {{ $t('plan.suppliersCount') }}
                        </div>
                        <div class="col text-center fixed-height my-auto table-sub-cell py-5">150</div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="col text-center fixed-height py-5 table-sub-cell my-auto">
                            {{ $t('plan.customersCount') }}
                        </div>
                        <div class="col text-center fixed-height my-auto table-sub-cell py-5">150</div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div
                            class="col d-flex align-items-center justify-content-center fixed-height table-sub-cell cell-title-price cell-fixed-height">
                            {{ $t('plan.priceForMonth') }}
                        </div>
                        <div class="col table-sub-cell fixed-height my-auto py-5">
                            <b-button
                                variant="primary"
                                @click="checkPreviousPlan('standartM')"
                                class="w-100"
                                style="background-color: blue; border: none"
                            >
                                490 000 {{ $t('currencyRate.sum') }}
                            </b-button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div
                            class="col d-flex align-items-center text-center fixed-height table-sub-cell cell-title-price cell-fixed-height">
                            {{ $t('plan.priceForYear') }}
                        </div>
                        <div class="col d-flex align-items-center table-sub-cell fixed-height py-5">
                            <b-button
                                variant="primary"
                                @click="checkPreviousPlan('standartA')"
                                class="w-100"
                                style="background-color: blue; border: none"
                            >
                               4 900 000 {{ $t('currencyRate.sum') }}
                            </b-button>
                        </div>
                    </div>
                </div>

                <div class="col mt-4 p-0">
                    <div class="col text-center my-auto p-2 plan-premium table-border">Premium</div>
                </div>
                <div class="col table-body p-0">
                    <div class="d-flex justify-content-center">
                        <div class="col text-justify table-cell" style="overflow: auto">
                            <div class="text-center my-2 cell-title">{{ $t('plan.statistics') }}</div>
                            <p style="font-size: 15px">{{ $t('plan.statisticsTitle') }}</p>
                        </div>
                        <div class="col d-flex align-items-center justify-content-center table-cell">
                            <span class="checkmark">&#10003;</span>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="col text-center fixed-height py-5 table-sub-cell my-auto">
                            {{ $t('plan.employeesCount') }}
                        </div>
                        <div class="col text-center fixed-height my-auto table-sub-cell py-5">
                            <span class="checkmark-i">&infin;</span>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="col text-center fixed-height py-5 table-sub-cell my-auto">
                            {{ $t('plan.warehousesCount') }}
                        </div>
                        <div class="col text-center fixed-height my-auto table-sub-cell py-5">
                            <span class="checkmark-i">&infin;</span>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="col text-center fixed-height py-5 table-sub-cell my-auto">
                            {{ $t('plan.suppliersCount') }}
                        </div>
                        <div class="col text-center fixed-height my-auto table-sub-cell py-5">
                            <span class="checkmark-i">&infin;</span>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="col text-center fixed-height py-5 table-sub-cell my-auto">
                            {{ $t('plan.customersCount') }}
                        </div>
                        <div class="col text-center fixed-height my-auto table-sub-cell py-5">
                            <span class="checkmark-i">&infin;</span>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div
                            class="col d-flex align-items-center justify-content-center fixed-height table-sub-cell cell-title-price cell-fixed-height">
                            {{ $t('plan.priceForMonth') }}
                        </div>
                        <div class="col d-flex align-items-center justify-content-center table-sub-cell fixed-height">
                            <b-button
                                variant="primary"
                                @click="checkPreviousPlan('premiumM')"
                                class="w-100"
                                style="background-color: green; border: none"
                            >
                                990 000 {{ $t('currencyRate.sum') }}
                            </b-button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div
                            class="col d-flex align-items-center justify-content-center text-center fixed-height table-sub-cell cell-title-price cell-fixed-height">
                            {{ $t('plan.priceForYear') }}
                        </div>
                        <div class="col d-flex align-items-center justify-content-center table-sub-cell fixed-height">
                            <b-button
                                variant="primary"
                                @click="checkPreviousPlan('premiumA')"
                                class="w-100"
                                style="background-color: green; border: none"
                            >
                                9 900 000 {{ $t('currencyRate.sum') }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </RowColumn>

            <!--   desktop version   -->
            <RowColumn class="mt-3 d-none d-md-block">
                <div class="col d-flex p-0 mb-3">
                    <div class="col-3 text-center font-bold text-gray-500 pt-2 h-11 feature">{{ $t('plan.feature') }}</div>
                    <div class="col-3 text-center font-bold text-white pt-2 h-11 plan-lite">Lite</div>
                    <div class="col-3 text-center font-bold text-white pt-2 h-11 plan-standart">Standart</div>
                    <div class="col-3 text-center font-bold text-white pt-2 h-11 plan-premium">Premium</div>
                </div>
                <div class="col text-gray-500 font-bold text-center py-2">
                    {{ $t('plan.conditions') }}
                </div>
                <div class="col d-flex table-body p-0">
                    <div class="col-3 text-justify table-cell" style="overflow: auto">
                        <div class="text-center my-2 cell-title text-gray-500 font-bold">{{ $t('plan.statistics') }}</div>
                        <p class="text-xs text-gray-500">{{ $t('plan.statisticsTitle') }}</p>
                    </div>
                    <div class="col-3 d-flex align-items-center justify-content-center table-cell">
                        <span class="checkmark-n">&#10005;</span>
                    </div>
                    <div class="col-3 d-flex align-items-center justify-content-center my-auto table-cell">
                        <span class="checkmark">&#10003;</span>
                    </div>
                    <div class="col-3 d-flex align-items-center justify-content-center my-auto table-cell">
                        <span class="checkmark">&#10003;</span>
                    </div>
                </div>
                <div class="col d-flex table-body p-0">
                    <div class="col-3 d-flex align-items-center justify-content-center text-justify table-sub-cell">
                        <div class="text-center cell-title text-gray-500 font-bold">{{ $t('plan.employeesCount') }}</div>
                    </div>
                    <div class="col-3 d-flex align-items-center justify-content-center table-sub-cell">1</div>
                    <div class="col-3 d-flex align-items-center justify-content-center table-sub-cell">10</div>
                    <div class="col-3 d-flex align-items-center justify-content-center table-sub-cell">
                        <span class="checkmark-i">&infin;</span>
                    </div>
                </div>
                <div class="col d-flex table-body p-0">
                    <div class="col-3 d-flex align-items-center justify-content-center text-justify table-sub-cell">
                        <div class="text-center cell-title text-gray-500 font-bold">{{ $t('plan.warehousesCount') }}</div>
                    </div>
                    <div class="col-3 d-flex align-items-center justify-content-center table-sub-cell">1</div>
                    <div class="col-3 d-flex align-items-center justify-content-center table-sub-cell">5</div>
                    <div class="col-3 d-flex align-items-center justify-content-center table-sub-cell">
                        <span class="checkmark-i">&infin;</span></div>
                </div>
                <div class="col d-flex table-body p-0">
                    <div class="col-3 d-flex align-items-center justify-content-center text-justify table-sub-cell">
                        <div class="text-center cell-title text-gray-500 font-bold">{{ $t('plan.suppliersCount') }}</div>
                    </div>
                    <div class="col-3 d-flex align-items-center justify-content-center table-sub-cell">50</div>
                    <div class="col-3 d-flex align-items-center justify-content-center table-sub-cell">150</div>
                    <div class="col-3 d-flex align-items-center justify-content-center table-sub-cell">
                        <span class="checkmark-i">&infin;</span></div>
                </div>
                <div class="col d-flex table-body p-0">
                    <div class="col-3 d-flex align-items-center justify-content-center text-justify table-sub-cell">
                        <div class="text-center cell-title text-gray-500 font-bold">{{ $t('plan.customersCount') }}</div>
                    </div>
                    <div class="col-3 d-flex align-items-center justify-content-center table-sub-cell">50</div>
                    <div class="col-3 d-flex align-items-center justify-content-center table-sub-cell">150</div>
                    <div class="col-3 d-flex align-items-center justify-content-center table-sub-cell">
                        <span class="checkmark-i">&infin;</span></div>
                </div>

                <!--        plan for month        -->
                <div class="col d-flex table-body p-0">
                    <div class="col-3 d-flex align-items-center justify-content-center text-justify table-sub-cell">
                        <div class="text-center py-4 cell-title-price text-gray-500 font-bold">{{ $t('plan.priceForMonth') }}</div>
                    </div>
                    <div class="col-3 d-flex align-items-center justify-content-center table-sub-cell">
                        <b-button
                            @click="checkPreviousPlan('liteM')"
                            class="w-100 font-bold"
                            style="background-color: red; border: none"
                        >
                            249 000 {{ $t('currencyRate.sum') }}
                        </b-button>
                    </div>
                    <div class="col-3 d-flex align-items-center justify-content-center text-center table-sub-cell py-4">
                        <b-button
                            variant="primary"
                            @click="checkPreviousPlan('standartM')"
                            class="w-100 font-bold"
                            style="background-color: blue; border: none"
                        >
                            490 000 {{ $t('currencyRate.sum') }}
                        </b-button>
                    </div>
                    <div class="col-3 d-flex align-items-center justify-content-center text-center table-sub-cell">
                        <b-button
                            variant="primary"
                            @click="checkPreviousPlan('premiumM')"
                            class="w-100 font-bold"
                            style="background-color: green; border: none"
                        >
                            990 000 {{ $t('currencyRate.sum') }}
                        </b-button>
                    </div>
                </div>

                <!--  plan for year-->
                <div class="col d-flex table-body p-0">
                    <div class="col-3 d-flex align-items-center justify-content-center text-justify table-sub-cell">
                        <div class="text-center py-4 cell-title-price text-gray-500 font-bold">
                            {{ $t('plan.priceForYear') }}
                        </div>
                    </div>
                    <div class="col-3 d-flex align-items-center justify-content-center text-center table-sub-cell">
                        <b-button
                            variant="primary"
                            @click="checkPreviousPlan('liteA')"
                            class="w-100 font-bold"
                            style="background-color: red; border: none"
                        >
                            2 490 000 {{ $t('currencyRate.sum') }}
                        </b-button>
                    </div>
                    <div class="col-3 d-flex align-items-center justify-content-center text-center table-sub-cell">
                        <b-button
                            variant="primary"
                            @click="checkPreviousPlan('standartA')"
                            class="w-100 font-bold"
                            style="background-color: blue; border: none"
                        >
                            4 900 000 {{ $t('currencyRate.sum') }}
                        </b-button>
                    </div>
                    <div class="col-3 d-flex align-items-center justify-content-center text-center table-sub-cell">
                        <b-button
                            variant="primary"
                            @click="checkPreviousPlan('premiumA')"
                            class="w-100 font-bold"
                            style="background-color: green; border: none"
                        >
                            9 900 000 {{ $t('currencyRate.sum') }}
                        </b-button>
                    </div>
                </div>
            </RowColumn>

        </Row>

        <!-- Start Payme Form -->
        <form method="POST" class="d-none" action="https://checkout.paycom.uz">

            <!-- todo move merchant value to .env file  -->
            <!-- Идентификатор WEB Кассы -->
            <input type="hidden" name="merchant" value="5ede954047a625d64690ed9e"/>

            <!-- Сумма платежа в тийинах -->
            <input type="hidden" name="amount" :value="payme.amount"/>

            <!-- Поля Объекта Account -->
            <input type="hidden" name="account[transactionId]" :value="payme.transactionId"/>

            <!-- ==================== НЕОБЯЗАТЕЛЬНЫЕ ПОЛЯ ====================== -->
            <!-- Язык. Доступные значения: ru|uz|en
                 Другие значения игнорируются
                 Значение по умолчанию ru -->
            <input type="hidden" name="lang" :value="$i18n.locale"/>

            <!-- Валюта. Доступные значения: 643|840|860|978
                 Другие значения игнорируются
                 Значение по умолчанию 860
                 Коды валют в ISO формате
                 643 - RUB
                 840 - USD
                 860 - UZS
                 978 - EUR -->
            <input type="hidden" name="currency" value="860"/>

            <!-- URL возврата после оплаты или отмены платежа.
                 Если URL возврата не указан, он берется из заголовка запроса Referer.
                 URL возврата может содержать параметры, которые заменяются Paycom при запросе.
                 Доступные параметры для callback:
                 :transaction - id транзакции или "null" если транзакцию не удалось создать
                 :account.{field} - поля объекта Account
                 Пример: https://your-service.uz/paycom/:transaction -->
            <!--            <input type="hidden" name="callback" value="http://boshqar.uz/products/?transaction=:transaction&orderId=:account.orderId"/>-->

            <!-- Таймаут после успешного платежа в миллисекундах.
                 Значение по умолчанию 15
                 После успешной оплаты, по истечении времени callback_timeout
                 производится перенаправление пользователя по url возврата после платежа -->
            <input type="hidden" name="callback_timeout" value="15"/>

            <!-- Выбор платежного инструмента Paycom.
                 В Paycom доступна регистрация несколько платежных
                 инструментов. Если платёжный инструмент не указан,
                 пользователю предоставляется выбор инструмента оплаты.
                 Если указать id определённого платежного инструмента -
                 пользователь перенаправляется на указанный платежный инструмент. -->
            <!--            <input type="hidden" name="payment" value="{payment_id}"/>-->

            <!-- Описание платежа
                 Для описания платежа доступны 3 языка: узбекский, русский, английский.
                 Для описания платежа на нескольких языках следует использовать
                 несколько полей с атрибутом  name="description[{lang}]"
                 lang может принимать значения ru|en|uz -->
            <input type="hidden" name="description" :value="payme.description"/>

            <!-- Объект детализации платежа
                 Поле для детального описания платежа, например, перечисления
                 купленных товаров, стоимости доставки, скидки.
                 Значение поля (value) — JSON-строка закодированная в BASE64 -->
            <!--
             {
                "discount" : { //скидка, необязательное поле
                     "title" : "Скидка 5%", "price" : 10000
               },
                "shipping" : { //доставка, необязательное поле
                      "title" : "Доставка до ттз-4 28/23", "price" : 500000
                },
                "items" : [
                        { //товарная позиция, необязательное поле
                        "title" : "Помидоры", "price" : 505000, "count" : 2}
                ]
            }
             -->
            <input type="hidden" name="detail" :value="payme.detail"/>
            <!-- ================================================================== -->

            <button type="submit" ref="paymeButton">Оплатить с помощью <b>Payme</b></button>
        </form>

    </Row>
</template>

<script>
import Row from "../../components/html/Row";
import {mapActions, mapGetters} from "vuex";
import RowColumn from "@/components/RowColumn";
import Modal from "@/components/html/Modal";

export default {
    name: "Compare",
    components: {Modal, RowColumn, Row},
    computed: {
        ...mapGetters(['getPayme', 'getUserCompany', 'isAuthenticated']),
    },
    data() {
        return {
            modalText: '',
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'plan.compare'},
            ],
            selectedPlanName: '',
            payme: {
                amount: 49000000,
                description: "Оплата абонентской платы за 1 год",
                transactionId: 0,
                detail: null
            },
            detail: {
                items: [
                    {
                        count: 1,
                        title: '',
                        price: '',
                        code: process.env.VUE_APP_IKPU_CODE,
                        package_code: process.env.VUE_APP_PACKAGE_CODE,
                        vat_percent: 0
                    }
                ],
            },
        }
    },
    methods: {
        ...mapActions(['pushPayme', 'fetchUser', 'setBreadcrumbItems']),
        b64EncodeUnicode(str) {
            return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
                function toSolidBytes(match, p1) {
                    return String.fromCharCode('0x' + p1);
                }));
        },
        pay(planName) {
            this.pushPayme(planName)
                .then(() => {
                    this.payme.amount = this.getPayme.amount
                    this.payme.transactionId = this.getPayme.id
                    this.detail.items[0].price = this.getPayme.amount

                    switch (this.$i18n.locale) {
                        case 'uz':
                            if (planName === 'liteM' || planName === 'standartM' || planName === 'premiumM') {
                                this.payme.description = `${process.env.VUE_APP_NAME} uchun 1 oylik to'lov`;
                                this.detail.items[0].title = this.payme.description
                                this.payme.detail = this.b64EncodeUnicode(JSON.stringify(this.detail))
                            } else {
                                this.payme.description = `${process.env.VUE_APP_NAME} uchun 1 yillik to'lov`;
                                this.detail.items[0].title = this.payme.description
                                this.payme.detail = this.b64EncodeUnicode(JSON.stringify(this.detail))
                            }
                            break;

                        case 'ru':
                            if (planName === 'liteM' || planName === 'standartM' || planName === 'premiumM') {
                                this.payme.description = `Оплата абонентской платы ${process.env.VUE_APP_NAME} за 1 месяц`;
                                this.detail.items[0].title = this.payme.description
                                this.payme.detail = this.b64EncodeUnicode(JSON.stringify(this.detail))
                            } else {
                                this.payme.description = `Оплата абонентской платы ${process.env.VUE_APP_NAME} за 1 год`;
                                this.detail.items[0].title = this.payme.description
                                this.payme.detail = this.b64EncodeUnicode(JSON.stringify(this.detail))
                            }
                            break;

                        case 'en':
                            if (planName === 'liteM' || planName === 'standartM' || planName === 'premiumM') {
                                this.payme.description = `${process.env.VUE_APP_NAME} subscription fee for a month`;
                                this.detail.items[0].title = this.payme.description
                                this.payme.detail = this.b64EncodeUnicode(JSON.stringify(this.detail))
                            } else {
                                this.payme.description = `${process.env.VUE_APP_NAME} subscription fee for a year`;
                                this.detail.items[0].title = this.payme.description
                                this.payme.detail = this.b64EncodeUnicode(JSON.stringify(this.detail))
                            }
                            break;
                    }
                })
                .then(() => {
                    this.$refs.paymeButton.click()
                })
        },
        checkPreviousPlan(planName) {
            if (!this.isAuthenticated) {
                this.$i18nHelper.toUrl('login')
                return
            }

            let previousPlan = this.getUserCompany.plans[0].planType.name
            this.selectedPlanName = planName

            switch (previousPlan) {
                case "free":
                case "premiumM":
                case "premiumA":
                    switch (planName) {
                        case "liteM":
                        case "liteA":
                        case "standartM":
                        case "standartA":
                            this.modalText = this.$t('plan.planChangeWarning')
                            this.$bvModal.show('modal_show')
                            break

                        case "premiumM":
                        case "premiumA":
                            this.continuePay()
                            break
                    }
                    break

                case "standartM":
                case "standartA":
                    switch (planName) {
                        case "liteM":
                        case "liteA":
                            this.modalText = this.$t('plan.planChangeWarning')
                            this.$bvModal.show('modal_show')
                            break

                        case "standartM":
                        case "standartA":
                        case "premiumM":
                        case "premiumA":
                            this.continuePay()
                    }
                    break

                case "liteM":
                case "liteA":
                    this.continuePay()
            }
        },
        continuePay() {
            this.pay(this.selectedPlanName)
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        if (this.isAuthenticated) {
            this.fetchUser()
        }
    }
}
</script>
<style scoped>
.table-border {
    border-radius: 5px;
}

.feature {
    background-color: #E9ECEF;
}

.plan-lite {
    background-color: red;
}

.plan-standart {
    background-color: blue;
}

.plan-premium {
    background-color: green;
}

.checkmark {
    color: green;
    font-size: 34px;
}

.checkmark-n {
    color: red;
    font-size: 34px;
}

.checkmark-i {
    font-size: 30px;
}

.table-sub-header-mobile {
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 5px;
    padding: 0 20px;
    text-align: center;
}

.table-cell {
    height: 200px;
}

.table-sub-cell {
    border-top: 1px solid rgba(0, 0, 0, 0.125);
    height: 60px;
}

.cell-title {
    font-size: 18px;
}

.cell-title-price {
    font-size: 20px;
}

.cell-fixed-height {
    height: 136px;
}

.fixed-height {
    height: 123px;
}
</style>
